import type { AssetsSelectParentOptionProps } from "./assets-select-parent-option.type";

import { Select, Tooltip } from "antd";

import { getAssetsSelectParentOptionItem } from "./assets-select-parent-option.helper";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

const AssetsSelectParentOption = ({
  option,
}: AssetsSelectParentOptionProps) => {
  const { value, label, truncatedLabel } =
    getAssetsSelectParentOptionItem(option);

  return (
    <Option key={value} value={value}>
      <Tooltip title={label}>{truncatedLabel}</Tooltip>
    </Option>
  );
};

export default AssetsSelectParentOption;
